import React, { useEffect, useState } from 'react';
import { StyledLabel, StyledSlider, StyledSwitchInput, StyledWrapper } from './style';

export interface SwitchProps {
  label?: string;
  checked?: boolean;
  onChange?: (value: boolean) => void;
}

const SwitchMini = ({ label, checked, onChange }: SwitchProps) => {
  const [localValue, setLocalValue] = useState(false);

  return (
    <StyledWrapper>
      <label>
        <StyledSwitchInput
          type="checkbox"
          checked={checked === undefined ? localValue : checked}
          onChange={(e) => {
            if (checked === undefined) {
              setLocalValue(!localValue);
              return;
            }

            onChange && onChange(e.target.checked);
          }}
        />
        <StyledSlider className="pa-switch-mini-slider" />

        {label && <StyledLabel>{label}</StyledLabel>}
      </label>
    </StyledWrapper>
  );
};

export default SwitchMini;
